import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { persistTenantBranding } from '../../components/common/tenantBranding';
import { redirectBasedOnRole } from '../../routes/decodedAdmin';

const EntraComplete: React.FC = () => {
  useEffect(() => {
    const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
    const params = new URLSearchParams(hash || window.location.search);
    const encoded = params.get('payload');
    const token = params.get('token');
    let data: {
      token?: string;
      uid?: string;
      tenant_id?: string;
      email?: string;
      fullName?: string;
      name?: string;
      logoUrl?: string;
      routes?: unknown;
      firstPage?: string;
    } = {};
    if (encoded) {
      try {
        data = JSON.parse(atob(encoded.replace(/-/g, '+').replace(/_/g, '/')));
      } catch {
        data = {};
      }
    }
    const jwt = data.token || token;
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        jwt
          ? { type: 'ENTRA_SSO_LOGIN', ok: true, payload: { ...data, token: jwt } }
          : { type: 'ENTRA_SSO_LOGIN', ok: false, message: 'Microsoft sign-in did not return a session.' },
        window.location.origin
      );
      window.close();
      return;
    }
    if (!jwt) return;
    persistEntraSession({ ...data, token: jwt });
    redirectBasedOnRole(jwt);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-neutral-900 text-white">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mb-4" />
      <h2 className="text-xl font-semibold">Signing you in with Microsoft...</h2>
    </div>
  );
};

export function persistEntraSession(data: {
  token: string;
  uid?: string;
  tenant_id?: string;
  email?: string;
  fullName?: string;
  name?: string;
  logoUrl?: string;
  routes?: unknown;
  firstPage?: string;
}) {
  localStorage.setItem('token', data.token);
  if (data.uid) localStorage.setItem('user_uid', String(data.uid));
  if (data.fullName) localStorage.setItem('user_name', data.fullName);
  if (data.email) localStorage.setItem('user_email', data.email);
  if (data.tenant_id) localStorage.setItem('tenant_id', String(data.tenant_id));
  localStorage.setItem('user_routes', JSON.stringify(Array.isArray(data.routes) ? data.routes : []));
  if (data.firstPage) localStorage.setItem('first_page', data.firstPage);
  else localStorage.removeItem('first_page');
  persistTenantBranding(data.name, data.logoUrl);
  Cookies.set('auth_token', data.token, { secure: true, sameSite: 'Strict' });
  if (data.tenant_id) Cookies.set('tenant_id', String(data.tenant_id));
}

export default EntraComplete;
